'use strict';

var _ = require('lodash');
var DashboardAggregatingService = function DashboardAggregatingService() {
  function add(v1, v2) {
    return _.isUndefined(v2) ? v1 : (v1 || 0) + v2;
  }
  function divide(v1, v2) {
    if (_.isNumber(v1) && _.isNumber(v2) && v2 !== 0) {
      return v1 / v2;
    }
    return undefined;
  }
  function aggregateBookingsRevenue(data, months, aggregationMode) {
    var aggregatedData = {};
    for (var i = 0; i < data.length; i++) {
      var element = data[i];
      if (_.isArray(months) && !_.includes(months, element.month)) {
        continue;
      }
      aggregatedData.current = add(aggregatedData.current, element.m1);
      aggregatedData.expected = add(aggregatedData.expected, element.m2);
      if (aggregationMode !== 'BUDGET' && aggregationMode !== 'TARGET') {
        aggregatedData.currentRef = add(aggregatedData.currentRef, element.m3[aggregationMode]);
        aggregatedData.finalRef = add(aggregatedData.finalRef, element.m4[aggregationMode]);
      }
      aggregatedData.budget = add(aggregatedData.budget, element.budget);
      aggregatedData.target = add(aggregatedData.target, element.target);
    }
    return _.omitBy(aggregatedData, _.isNil);
  }
  function addLf(result, item) {
    result = result || {};
    if (_.isNumber(item.loadFactorTimesCapacitySum) && _.isNumber(item.capacitySum)) {
      result.n = add(result.n || 0, item.loadFactorTimesCapacitySum);
      result.d = add(result.d || 0, item.capacitySum);
    }
    return result;
  }
  function divideLf(item) {
    if (item) {
      var result = divide(item.n, item.d);
      if (result) {
        return 100 * result;
      }
    }
    return undefined;
  }
  function aggregateLoadFactor(data, months, aggregationMode) {
    var budgetCounter = 0,
      targetCounter = 0;
    var aggregatedData = {};
    for (var i = 0; i < data.length; i++) {
      var element = data[i];
      if (_.isArray(months) && !_.includes(months, element.month)) {
        continue;
      }
      aggregatedData.current = addLf(aggregatedData.current, element.m1);
      aggregatedData.expected = addLf(aggregatedData.expected, element.m2);
      if (aggregationMode !== 'BUDGET' && aggregationMode !== 'TARGET') {
        aggregatedData.currentRef = addLf(aggregatedData.currentRef, element.m3[aggregationMode]);
        aggregatedData.finalRef = addLf(aggregatedData.finalRef, element.m4[aggregationMode]);
      }
      aggregatedData.budget = add(aggregatedData.budget, element.budget);
      aggregatedData.target = add(aggregatedData.target, element.target);
      if (element.budget !== undefined) {
        budgetCounter++;
      }
      if (element.target !== undefined) {
        targetCounter++;
      }
    }
    aggregatedData.current = divideLf(aggregatedData.current);
    aggregatedData.expected = divideLf(aggregatedData.expected);
    aggregatedData.currentRef = divideLf(aggregatedData.currentRef);
    aggregatedData.finalRef = divideLf(aggregatedData.finalRef);
    aggregatedData.budget = divide(aggregatedData.budget, budgetCounter);
    aggregatedData.target = divide(aggregatedData.target, targetCounter);
    return _.omitBy(aggregatedData, _.isNil);
  }
  function aggregateForMonths(data, metric, aggregationMode, months) {
    if (metric === 'loadFactor') {
      return aggregateLoadFactor(data, months, aggregationMode);
    } else {
      return aggregateBookingsRevenue(data, months, aggregationMode);
    }
  }
  return {
    aggregateForMonths: aggregateForMonths
  };
};
DashboardAggregatingService.$inject = [];
module.exports = DashboardAggregatingService;